import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { cfetch } from '@confluence/network';
import { wrmResourceRecorder } from '@confluence/ssr-utilities/entry-points/WRMResourceRecorder.ts';

import { convertResourceToScriptTags } from './convertResourceToScriptTags.ts';

/*
    Preload static WRM resources defined at next/packages/fabric-extension-lib/src/extensions-common/macro-loaders.ts
*/
export const preloadStaticWRM = async (): Promise<void> => {
	await SSRMeasures.run('ssr-app/preloadStaticWRM', async () => {
		const response = await cfetch('/wiki/rest/webResources/1.0/resources', {
			method: 'POST',
			body: JSON.stringify({
				r: ['confluence.web.resources:view-content'],
				c: [],
				xc: [],
				xr: [],
			}),
		});

		// If preloading is successful, record WRM resources and set window.__WRM_RESOURCES__ for client
		// Otherwise, ignore it, SPA will load the resources
		if (response.ok) {
			const data = await response.json();

			const css =
				data?.resources
					?.filter(
						(resource: { resourceType: string; key: string }) =>
							resource.resourceType === 'CSS' &&
							resource.key?.includes('confluence.web.resources:view-content'),
					)
					?.map((resource) => convertResourceToScriptTags(resource))
					?.join('\n') ?? '';

			const resources = { css, js: '' };
			wrmResourceRecorder.setResources(resources);
			wrmResourceRecorder.setPreloaded(true);
			if (window) {
				window.__WRM_RESOURCES__ = wrmResourceRecorder.getResources();
			}
		}
	});
};
